<div class="quiz-progress-overlay">
  <div class="quiz-progress-card">
    <p class="quiz-progress-text">
      <ng-template #addingQuestion>
		<i class="bi bi-stars text-warning"></i>
		Adding your question...</ng-template>
		<ng-container *ngIf="progress === 100 ; else addingQuestion"> Manual questions added successfully!
			<mat-icon class="success-bg">verified</mat-icon>
		</ng-container>
    </p>
    <div class="progress-bar-container">
      <div class="progress-bar" [style.width.%]="progress"></div>
    </div>
    <p class="progress-percent">{{ progress }}%</p>
  </div>
</div>
